import { ApiResponse } from 'apisauce';

import { ISettingGateway } from './settingBase';

import { GatewayResponse, ProtectedRoute } from '~types/gateway';

import UtilFunctions from '~utils/functions';
import { TAPIKeyHistoryListingApiParams, TAPIKeyHistoryListingResponse, TAPIKeySettingsReduxResponse, TCreateAdminSettingsAPIParams, TGetPendingProductListingReduxResponse, TGetPendingProjectListingReduxResponse, TGetProductChangeHistoryAPIParams, TGetProjectChangeHistoryAPIParams, TGetSettingsAPIParams, TGetSettingsAPIResponse, TUpdateGlobalAndProductSettingsAPIParams } from '~types/feat/setting';
import { TAPIKeyHistoryListing } from '~types/redux/state';

const { API: { getHeaders } } = UtilFunctions;

export default class SettingGateway extends ISettingGateway {
    async getSettings(params: TGetSettingsAPIParams): GatewayResponse<TGetSettingsAPIResponse> {
        const { authToken, ...restOfGetSettingsAPIParams } = params;
        const response: ApiResponse<TGetSettingsAPIResponse> = await this.api.get('/adminSetting/getAdminSettings', restOfGetSettingsAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async updateSettings(params: TUpdateGlobalAndProductSettingsAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfUpdatetSettingsAPIParams } = params;
        const response: ApiResponse<null> = await this.api.put('/adminSetting/updateAdminSettings', restOfUpdatetSettingsAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getProductChangeHistoryListing(params: TGetProductChangeHistoryAPIParams): GatewayResponse<TGetPendingProductListingReduxResponse> {
        const { authToken, ...restOfGetProductChangeHistoryAPIParams } = params;
        const response: ApiResponse<TGetPendingProductListingReduxResponse> = await this.api.get('/adminSetting/getAdminSettingChangeHistoryListing', restOfGetProductChangeHistoryAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async getApiKeySettings(params: ProtectedRoute): GatewayResponse<TAPIKeySettingsReduxResponse> {
        const { authToken } = params;
        const response: ApiResponse<TAPIKeySettingsReduxResponse> = await this.api.get('/dashboard/getGoldSyncAPIKey', {}, getHeaders(authToken));
        return this.process(response);
    }

    async updateApiKeySettings(params: ProtectedRoute): GatewayResponse<TAPIKeySettingsReduxResponse> {
        const { authToken } = params;
        const response: ApiResponse<TAPIKeySettingsReduxResponse> = await this.api.put('/dashboard/updateGoldSyncAPIKey', {}, getHeaders(authToken));
        return this.process(response);
    }

    async getApiKeyHistoryListing(params: TAPIKeyHistoryListingApiParams): GatewayResponse<TAPIKeyHistoryListingResponse> {
        const { authToken, index } = params;
        const response: ApiResponse<TAPIKeyHistoryListingResponse> = await this.api.get('/dashboard/getGoldSyncAPIKeyHistory', { index }, getHeaders(authToken));
        return this.process(response);
    }

    async getSilverApiKeySettings(params: ProtectedRoute): GatewayResponse<TAPIKeySettingsReduxResponse> {
        const { authToken } = params;
        const response: ApiResponse<TAPIKeySettingsReduxResponse> = await this.api.get('/dashboard/api-keys/silver', {}, getHeaders(authToken));
        return this.process(response);
    }

    async updateSilverApiKeySettings(params: ProtectedRoute): GatewayResponse<TAPIKeySettingsReduxResponse> {
        const { authToken } = params;
        const response: ApiResponse<TAPIKeySettingsReduxResponse> = await this.api.put('/dashboard/api-keys/silver', {}, getHeaders(authToken));
        return this.process(response);
    }

    async getSilverApiKeyHistoryListing(params: TAPIKeyHistoryListingApiParams): GatewayResponse<TAPIKeyHistoryListingResponse> {
        const { authToken, index } = params;
        const response: ApiResponse<TAPIKeyHistoryListingResponse> = await this.api.get('/dashboard/api-keys/silver/history', { index }, getHeaders(authToken));
        return this.process(response);
    }

    async getProjectChangeHistoryListing(params: TGetProjectChangeHistoryAPIParams): GatewayResponse<TGetPendingProjectListingReduxResponse> {
        const { authToken, ...restOfGetProjectChangeHistoryAPIParams } = params;
        const response: ApiResponse<TGetPendingProjectListingReduxResponse> = await this.api.get('/project/getProjectChangeHistoryListing', restOfGetProjectChangeHistoryAPIParams, getHeaders(authToken));
        return this.process(response);
    }

    async createAdminSettings(params: TCreateAdminSettingsAPIParams): GatewayResponse<null> {
        const { authToken, ...restOfCreateAdminSettingsAPIParams } = params;
        const response: ApiResponse<null> = await this.api.post('/adminSetting/createAdminSettings', restOfCreateAdminSettingsAPIParams, getHeaders(authToken));
        return this.process(response);
    }

}
